import { cn } from '../utils/cn';

export interface AvatarProps {
  src?: string;
  name?: string;
  size?: number;
  className?: string;
}

export function Avatar({ src, name = '?', size = 36, className }: AvatarProps) {
  const initials = name
    .split(' ')
    .map((p) => p[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <div
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      className={cn(
        'inline-flex items-center justify-center rounded-full bg-[var(--color-primary)] text-[var(--color-primary-fg)] font-semibold overflow-hidden',
        className
      )}
    >
      {src ? <img src={src} alt={name} className="h-full w-full object-cover" /> : initials}
    </div>
  );
}

export default Avatar;
